import { useState } from "react";
import { fmtEth, fmtUsd } from "../../lib/api";

export const Calculator = ({ stats }) => {
  const [amount, setAmount] = useState("10000000");
  const awaiting = !stats || stats.awaiting_deployment;

  const supply = awaiting ? 0 : stats.eligible_supply;
  const perCycleVault = awaiting ? 0 : stats.vault_pending_eth;
  const cycleLen = stats?.cycle_length || stats?.cycle_seconds || 1800;
  const cyclesPerDay = 86400 / cycleLen;

  const amt = parseFloat(amount) || 0;
  const pct = supply > 0 ? Math.min((amt / supply) * 100, 100) : 0;
  const ethPerCycle = supply > 0 ? (amt / supply) * perCycleVault : 0;
  const ethPerDay = ethPerCycle * cyclesPerDay;

  return (
    <section className="max-w-7xl mx-auto px-6 py-12">
      <div className="grid lg:grid-cols-2 gap-8 items-stretch">
        <div className="card-surface rounded-2xl p-10">
          <p className="font-mono text-xs tracking-[0.2em] text-[#00C805] uppercase mb-3">Payout math</p>
          <h2 className="font-heading font-bold text-lg tracking-tight mb-8">What would you earn?</h2>
          <label className="font-mono text-[10px] tracking-[0.2em] text-neutral-500 uppercase block mb-2">Your $BANK amount</label>
          <input
            data-testid="calculator-input"
            type="number"
            min="0"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            className="w-full bg-[#050505] border border-white/10 rounded-xl px-5 py-4 font-mono text-2xl text-white focus:outline-none focus:border-[#00C805]/60 transition-colors duration-200"
          />
          <p className="mt-4 text-xs text-neutral-500 leading-relaxed">
            Estimates use the live vault flow rate (ETH queued this cycle) and current eligible
            supply. Actual payouts vary with trading volume.
          </p>
        </div>
        <div className="grid grid-cols-2 gap-4">
          <div className="card-surface rounded-2xl p-8 col-span-2">
            <p className="font-mono text-[10px] tracking-[0.2em] text-neutral-500 uppercase">Your share of supply</p>
            <p data-testid="calculator-percent" className="font-mono font-semibold text-4xl mt-3 text-[#00C805]">
              {awaiting ? "—" : `${pct.toFixed(4)}%`}
            </p>
          </div>
          <div className="card-surface rounded-2xl p-8">
            <p className="font-mono text-[10px] tracking-[0.2em] text-neutral-500 uppercase">ETH per cycle</p>
            <p data-testid="calculator-per-cycle" className="font-mono font-semibold text-2xl mt-3">
              {awaiting ? "—" : fmtEth(ethPerCycle, 8)}
            </p>
            <p className="text-xs text-neutral-500 mt-1 font-mono">{awaiting || !stats.eth_usd ? "" : fmtUsd(ethPerCycle * stats.eth_usd)}</p>
          </div>
          <div className="card-surface rounded-2xl p-8 border-t-2 border-t-[#00C805]">
            <p className="font-mono text-[10px] tracking-[0.2em] text-neutral-500 uppercase">ETH per day</p>
            <p data-testid="calculator-per-day" className="font-mono font-semibold text-2xl mt-3 text-[#00C805]">
              {awaiting ? "—" : fmtEth(ethPerDay, 8)}
            </p>
            <p className="text-xs text-neutral-500 mt-1 font-mono">
              {awaiting ? "Awaiting deployment" : `${Math.round(cyclesPerDay)} payouts / day`}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
